var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 361.5 478.1",
    style: {
      enableBackground: "new 0 0 361.5 478.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#414042;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#414042;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:25;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,205l96.5,1.3c2.5,1.1,7.4,3.6,11.9,10c5.5,7.8,7.3,16.8,7.8,20.5c0.1,78.9,0.2,157.7,0.2,236.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,122.6h95.4c2.1-0.7,10.1-3.8,15.8-15.2c5.2-10.3,5.3-21.1,5.2-24.5V0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.1,122.6H204c-2.1-0.7-10.1-3.8-15.8-15.2C183,97.1,182.9,86.4,183,83V0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.2,205h-40.8c-2.8,2.3-5,5.1-6.7,8.2c-4.7,8.7-4.8,18.4-4.7,21.6v65.4c6-18.2,13.6-35.8,22.8-52.6 C214,232.4,223.9,218.1,235.2,205z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360.1,215.8c-17.3,1.8-57.2,9.7-93.9,52.8c-63.9,74.8-63.8,191.5-63.6,207.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.5,470.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-72.8,254.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadA);
export default __webpack_public_path__ + "static/media/road-A.2b206beeec4f5d4afbd1f958aef0a4fc.svg";
export { ForwardRef as ReactComponent };